export const Criticality_00 = 'criticality-00';
export const Criticality_10 = 'criticality-10';
export const Criticality_20 = 'criticality-20';
export const criticalityValues = [Criticality_00, Criticality_10, Criticality_20];
//# sourceMappingURL=types.js.map